import { Link } from "react-router-dom";

const logoUrl = "https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/9aa924cb31af5202bbd782f0a24da659.png";

const quickLinks = [
  { path: "/", label: "首頁" },
  { path: "/about", label: "關於我" },
  { path: "/testimonials", label: "成功見證" },
  { path: "/system", label: "芳香創富系統" },
  { path: "/coaching", label: "教練服務 / 課程" },
  { path: "/contact", label: "聯繫我 / 加入團隊" },
];

const socialLinks = [
  {
    href: "https://line.me/R/ti/p/@your-id",
    icon: "ri-line-line",
    label: "LINE",
  },
  {
    href: "https://www.facebook.com/groups/your-group",
    icon: "ri-facebook-line",
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/your-handle",
    icon: "ri-instagram-line",
    label: "Instagram",
  },
  {
    href: "https://www.youtube.com/@your-handle",
    icon: "ri-youtube-line",
    label: "YouTube",
  },
  {
    href: "https://www.tiktok.com/@your-handle",
    icon: "ri-tiktok-line",
    label: "TikTok",
  },
  {
    href: "https://www.threads.net/@your-handle",
    icon: "ri-threads-line",
    label: "Threads",
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-white">
      {/* Upper */}
      <div className="mx-auto max-w-[1120px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-3">
              <img
                src={logoUrl}
                alt="香氛女王的幸福大地 Logo"
                title="香氛女王的幸福大地"
                className="h-[52px] w-auto object-contain flex-shrink-0"
              />
              <h3 className="text-[1.375rem] font-semibold text-primary-500">
                香氛女王的幸福大地
              </h3>
            </div>
            <p className="text-[1rem] leading-relaxed text-white/75 mb-5">
              讓香氣，帶你遇見更好的自己與人生
            </p>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/25 text-white hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-[1.125rem]`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="text-[1rem] font-semibold mb-4 text-white/90">
              快速連結
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[1rem] text-white/70 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-[1rem] font-semibold mb-4 text-white/90">
              課程服務
            </h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-[1rem] text-white/70">
                  芳香創富系統課程
                </span>
              </li>
              <li>
                <span className="text-[1rem] text-white/70">
                  女性創業教練班
                </span>
              </li>
              <li>
                <span className="text-[1rem] text-white/70">
                  團隊培訓與授權系統
                </span>
              </li>
              <li>
                <span className="text-[1rem] text-white/70">
                  VIP 芳療創富俱樂部
                </span>
              </li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div className="md:col-span-3">
            <h4 className="text-[1rem] font-semibold mb-4 text-white/90">
              免責提醒
            </h4>
            <p className="text-[1rem] leading-relaxed text-white/65">
              本網站內容為芳香生活、個人成長與事業系統分享，不構成醫療建議、療效保證或收入保證。實際成果依個人投入、學習狀況、行動力與市場環境而不同。
            </p>
          </div>
        </div>
      </div>

      {/* Lower */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1120px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[1rem] text-white/55">
            &copy; {new Date().getFullYear()} 香氛女王的幸福大地 Aroma Wealth
            Queen. All rights reserved.
          </p>
          <a
            href="https://vpivip.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[0.6875rem] sm:text-[0.75rem] text-white/40 hover:text-white/55 transition-colors duration-200 cursor-pointer"
          >
            品牌官網設計｜天地人網整合行銷
          </a>
        </div>
      </div>
    </footer>
  );
}